export const isMessagePort = (sender) => {
    return typeof sender.start === 'function';
};
//# sourceMappingURL=message-port.js.map